"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxCreateO365AccountArgs = void 0;
var HxServerTokenAuthInfoDataArgs_1 = require("./HxServerTokenAuthInfoDataArgs");
function serializeHxCreateO365AccountArgs(_arg) {
    var output = [];
    output.push(_arg.displayName);
    output.push(_arg.userDisplayName);
    output.push(_arg.emailAddress);
    output.push(_arg.serverUrl);
    output.push(HxServerTokenAuthInfoDataArgs_1.serializeHxServerTokenAuthInfoDataArgs(_arg.authInfo));
    output.push(_arg.cloudEnvironmentForAAD !== undefined);
    if (_arg.cloudEnvironmentForAAD !== undefined) {
        output.push(_arg.cloudEnvironmentForAAD);
    }
    output.push(_arg.primaryAccountIdForSharedAccount !== undefined);
    if (_arg.primaryAccountIdForSharedAccount !== undefined) {
        output.push(_arg.primaryAccountIdForSharedAccount.toString());
    }
    return output;
}
exports.serializeHxCreateO365AccountArgs = serializeHxCreateO365AccountArgs;
